var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconToolbarBack = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 29,
  viewBox: "0 0 28 29",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .5h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.725 7.793a1 1 0 0 1 1.497 1.32l-.083.094-5.226 5.224 5.226 5.226a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-5.932-5.932a1 1 0 0 1-.083-1.32l.083-.094z"
}))));
export { SvgIconToolbarBack as ReactComponent };
export default __webpack_public_path__ + "assets/images/icon-toolbar-back.svg";